import { type ReactElement, useId } from 'react';

interface PlacementConsentProps {
  /** 라벨 글자 그대로 — 동의 항목 이름이다(다른 글자를 섞지 않는다). */
  readonly label: string;
  readonly checked: boolean;
  readonly disabled: boolean;
  readonly onChange: (checked: boolean) => void;
}

/**
 * 주문하기 동의 한 줄 — 줄 전체가 체크박스 라벨이라 휴대폰에서도 44px 이상을 누를 수 있다.
 * 오른쪽 '필수'는 라벨 밖에 둬 동의 항목 이름을 바꾸지 않고, 체크박스 설명(aria-describedby)으로 이어 낭독기에도 알린다.
 */
export const PlacementConsent = ({
  label,
  checked,
  disabled,
  onChange,
}: PlacementConsentProps): ReactElement => {
  const requiredId = useId();

  return (
    <li className="flex items-center justify-between gap-4">
      <label className="flex min-h-14 flex-1 cursor-pointer items-center gap-3 py-3 text-sm leading-snug has-disabled:cursor-not-allowed has-disabled:opacity-60">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          aria-describedby={requiredId}
          className="size-5 shrink-0 cursor-pointer accent-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed"
          onChange={(event) => onChange(event.target.checked)}
        />
        {label}
      </label>
      <span id={requiredId} className="shrink-0 text-xs text-muted-foreground">
        필수
      </span>
    </li>
  );
};
